import React from 'react';
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Typography,
  Button,
  Rating,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableRow,
  IconButton,
} from '@mui/material';
import ShareIcon from '@mui/icons-material/Share';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const ProductDetails = ({ product }) => {
  const mockProduct = {
    title: "2P9X9 PowerEdge T310 LGA 1156 DDR3 SDRAM Server Motherboard",
    brand: "Generic",
    price: 115.99,
    rating: 4.6,
    reviews: 7261,
    isPrime: true,
    specifications: {
      brand: "Generic",
      cpuSocket: "LGA 1156",
      compatibleDevices: "Dell PowerEdge T310",
      ramMemoryTechnology: "DDR3",
      compatibleProcessors: "Intel Core i5-661, Intel Core i7-870, Intel Core i7-950, Intel Core i5-2400, Intel Core i7-2600",
      chipsetType: "Intel Q57",
      memorySpeed: "1333 MHz",
      platform: "Windows",
      series: "PowerEdge T310",
      memoryStorageCapacity: "32 GB"
    }
  };

  return (
    <Box sx={{ maxWidth: '1500px', mx: 'auto', p: 2 }}>
      {/* Back Navigation */}
      <Button 
        startIcon={<ArrowBackIcon />} 
        sx={{ mb: 2, color: '#565959' }}
        href="#"
      >
        Back to results
      </Button>

      <Card sx={{
        width: '100%',
        bgcolor: 'background.paper',
        boxShadow: 'none',
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
      }}>
        {/* Left Section - Product Image */}
        <Box sx={{ 
          width: { xs: '100%', md: '40%' },
          p: 2,
          position: 'relative',
        }}>
          <IconButton 
            sx={{ 
              position: 'absolute', 
              right: 16, 
              top: 16,
              bgcolor: 'white',
              '&:hover': { bgcolor: '#f7f7f7' }
            }}
          >
            <ShareIcon />
          </IconButton>
          
          <CardMedia
            component="img"
            sx={{
              width: '100%',
              height: 'auto',
              objectFit: 'contain',
              cursor: 'zoom-in',
            }}
            image="https://placeholder.com/400x400"
            alt={mockProduct.title}
          />
          <Typography variant="caption" sx={{ display: 'block', textAlign: 'center', mt: 1 }}>
            Roll over image to zoom in
          </Typography>
        </Box>

        {/* Middle Section - Product Info */}
        <Box sx={{ 
          flex: 1,
          p: 2,
        }}>
          <Typography variant="h5" component="h1" sx={{ mb: 1 }}>
            {mockProduct.title}
          </Typography>

          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
            <Typography 
              component="a" 
              href="#" 
              sx={{ 
                color: '#007185',
                textDecoration: 'none',
                '&:hover': { color: '#C7511F', textDecoration: 'underline' }
              }}
            >
              Brand: {mockProduct.brand}
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <Rating value={mockProduct.rating} precision={0.5} readOnly size="small" />
            <Typography sx={{ ml: 1, color: '#007185' }} component="a" href="#">
              {mockProduct.reviews} ratings
            </Typography>
          </Box>

          <Divider sx={{ mb: 2 }} />

          <Box sx={{ mb: 2 }}>
            <Typography variant="h5" component="span" sx={{ color: '#0F1111' }}>
              ${mockProduct.price}
            </Typography>
            {mockProduct.isPrime && (
              <Typography 
                component="span" 
                sx={{ 
                  ml: 1,
                  color: '#0F1111',
                  fontSize: '0.9rem'
                }}
              >
                & FREE Returns
              </Typography>
            )}
          </Box>

          {/* Specifications Table */}
          <Table sx={{ mb: 3 }}>
            <TableBody>
              {Object.entries(mockProduct.specifications).map(([key, value]) => (
                <TableRow key={key} sx={{ 
                  '&:nth-of-type(odd)': { bgcolor: '#f7f7f7' },
                  '& td': { border: 0 }
                }}>
                  <TableCell 
                    component="th" 
                    sx={{ 
                      width: '200px',
                      color: '#565959',
                      fontWeight: 500,
                      pl: 0
                    }}
                  >
                    {key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}
                  </TableCell>
                  <TableCell>{value}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>

          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" color="error" sx={{ mb: 1 }}>
              Note: Products with electrical plugs are designed for use in the US. Outlets and voltage differ internationally and this product may require an adapter or converter for use in your destination. Please check compatibility before purchasing.
            </Typography>
          </Box>
        </Box>

        {/* Right Section - Buy Box */}
        <Box sx={{ 
          width: { xs: '100%', md: '250px' },
          p: 2,
          border: '1px solid #D5D9D9',
          borderRadius: 1,
          alignSelf: 'flex-start',
        }}>
          <Typography variant="h5" component="span" sx={{ color: '#0F1111', display: 'block', mb: 1 }}>
            ${mockProduct.price}
          </Typography>
          
          <Typography sx={{ color: '#565959', fontSize: '0.9rem', mb: 2 }}>
            No featured offers available
          </Typography>

          <Button
            variant="contained"
            fullWidth
            sx={{
              bgcolor: '#FFD814',
              color: '#0F1111',
              borderRadius: '20px',
              textTransform: 'none',
              mb: 1,
              '&:hover': {
                bgcolor: '#F7CA00',
              },
            }}
          >
            See All Buying Options
          </Button>

          <Button
            variant="outlined"
            fullWidth
            sx={{
              color: '#0F1111',
              borderColor: '#D5D9D9',
              borderRadius: '20px',
              textTransform: 'none',
              '&:hover': {
                borderColor: '#0F1111',
                bgcolor: 'transparent',
              },
            }}
          >
            Add to List
          </Button>
        </Box>
      </Card>
    </Box>
  );
};

export default ProductDetails; 